@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [class]="toast.classname"
    [autohide]="true"
    (hidden)="toastService.remove(toast)"
    [delay]="toast.delay || 3000"
    (hide)="toastService.remove(toast)"
    >
    @if (isTemplate(toast)) {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      {{ toast.textOrTpl }}
    }
    <div [inlineSVG]="'assets/ico/clear-button.svg'" class="icon fill-white clear-search-icon" alt="clear" (click)="toastService.remove(toast)"></div>
  </ngb-toast>
}